var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "justify-center": "" } },
    [
      _c(
        "v-flex",
        { attrs: { flex: "", md6: "" } },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "title" }, [
                _vm._v("Change your password")
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:8",
                        expression: "'required|min:8'"
                      }
                    ],
                    ref: "password",
                    attrs: {
                      "append-icon": _vm.showPass
                        ? "visibility_off"
                        : "visibility",
                      type: _vm.showPass ? "text" : "password",
                      name: "password",
                      "error-messages": _vm.errors.first("password"),
                      "data-vv-name": "password",
                      label: "Password",
                      "data-vv-as": "Password",
                      counter: ""
                    },
                    on: {
                      "click:append": function($event) {
                        _vm.showPass = !_vm.showPass
                      }
                    },
                    model: {
                      value: _vm.password,
                      callback: function($$v) {
                        _vm.password = $$v
                      },
                      expression: "password"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:8|confirmed:password",
                        expression: "'required|min:8|confirmed:password'"
                      }
                    ],
                    ref: "passwordConfirmation",
                    attrs: {
                      "append-icon": _vm.showPass
                        ? "visibility_off"
                        : "visibility",
                      type: _vm.showPass ? "text" : "password",
                      name: "password_confirmation",
                      "error-messages": _vm.errors.first(
                        "password_confirmation"
                      ),
                      "data-vv-name": "password_confirmation",
                      label: "Confirm your password",
                      "data-vv-as": "Password",
                      counter: ""
                    },
                    on: {
                      "click:append": function($event) {
                        _vm.showPass = !_vm.showPass
                      }
                    },
                    model: {
                      value: _vm.passwordConfirmation,
                      callback: function($$v) {
                        _vm.passwordConfirmation = $$v
                      },
                      expression: "passwordConfirmation"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.changePassword()
                        }
                      }
                    },
                    [_vm._v("Change password")]
                  ),
                  _vm._v(" "),
                  _c("v-spacer")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-552a02db", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-552a02db","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/User/ChangePassword.vue
// module id = null
// module chunks = 